import { createActions, createReducer } from "reduxsauce";

/**Actions and types definitions **/
export const { Types, Creators } = createActions({
  showHideToggleSidebar: null,
  showHideToggleArticlePaper: null,
});

interface IState {
  leftClassName: string;
  arrowClassName: string;
  isSideBarOpen: boolean;
  isArticlePaperOpen: boolean;
}

const INITIAL_STATE = {
  leftClassName: "left-inner-content",
  arrowClassName: "fa fa-arrow-right",
  isSideBarOpen: false,
  isArticlePaperOpen: false,
};

export const showHideToggleSidebar = (state = INITIAL_STATE): IState => {
  return {
    ...state,
    isSideBarOpen: !state.isSideBarOpen,
    leftClassName:
      state.leftClassName === "left-inner-content"
        ? "left-inner-content new-right"
        : "left-inner-content",
    arrowClassName:
      state.arrowClassName === "fa fa-arrow-right"
        ? "fa fa-arrow-left"
        : "fa fa-arrow-right",
  };
};

export const showHideToggleArticlePaper = (state = INITIAL_STATE): IState => {
  return {
    ...state,
    isArticlePaperOpen: !state.isArticlePaperOpen,
  };
};

export const HANDLERS = {
  [Types.SHOW_HIDE_TOGGLE_SIDEBAR]: showHideToggleSidebar,
  [Types.SHOW_HIDE_TOGGLE_ARTICLE_PAPER]: showHideToggleArticlePaper,
};
export default createReducer(INITIAL_STATE, HANDLERS);
